const HEX_RE = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i

export function isValidDisplayHex(s: string | null | undefined): s is string {
  if (s == null || typeof s !== 'string') return false
  return HEX_RE.test(s.trim())
}

export function normalizeTrustedHexInput(s: string): string | null {
  const t = s.trim()
  if (!isValidDisplayHex(t)) return null
  const h = t.slice(1)
  if (h.length === 3) {
    return `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`.toUpperCase()
  }
  return `#${h}`.toUpperCase()
}
